import React from "react";

//Styles
import "./NeedMore.scss";

//Components
import Button from "common-components/Button/Button";
import RevealOnScroll from "common-components/RevealOnScroll/RevealOnScroll";

//Data
import { serviceCardsExampleData } from "./exampleData";

function NeedMore() {
  return (
    <section className="page-landing need-more">
      <div className="m-width-wrapper">
        <RevealOnScroll>
          <h2>Need more than just a logo?</h2>
        </RevealOnScroll>
        <RevealOnScroll>
          <h3>
            Your brand is bigger than your company logo. Get everything you need to grow your business with one of these affordable logo design
            services:
          </h3>
        </RevealOnScroll>
        <RevealOnScroll threshold={0.1}>
          <div className="cards">
            {serviceCardsExampleData.map(({ photo, heading, description, price, saving }, index) => (
              <div key={index} className="service">
                <img src={photo} alt={heading} />
                <h4>{heading}</h4>
                <p>{description}</p>
                <div className="price">
                  from <span>${price}</span>
                </div>
                <div className="saving">
                  <span role="img" aria-label="Money Emoji">
                    💸
                  </span>
                  Save {saving}%+
                </div>
                <Button styleType="primary rounded">Learn More</Button>
              </div>
            ))}
          </div>
        </RevealOnScroll>
      </div>
    </section>
  );
}

export default NeedMore;
